import { render, staticRenderFns } from "./TransferModule.vue?vue&type=template&id=13c81001&scoped=true&"
import script from "./TransferModule.vue?vue&type=script&lang=ts&"
export * from "./TransferModule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c81001",
  null
  
)

export default component.exports